import { getAndReportExperiment } from '../../domains/experiments/selectors';
import type { YammerState } from '../../state/types';

const GraphqlApiV5EndpointEnabledOperations = [
  'CurrentUserClients',
  'FeatureAccessSettingsClients',
  'FeedGroupNestedClients',
];

export const GraphqlApiV5EndpointVersionNumber = 5;

export const isBackendGraphqlApiV5EndpointEnabledForOperation = (
  state: YammerState,
  operationName: string
): boolean => {
  const isBackendGraphqlApiV5EndpointEnabled = getAndReportExperiment(state, 'BackendGraphqlApiV5Endpoint') === true;

  return isBackendGraphqlApiV5EndpointEnabled && GraphqlApiV5EndpointEnabledOperations.includes(operationName);
};
